import { Ellipse } from '@/common/base/ellipse';
import type { WhatChangedBlock as WhatChangedBlockType } from '../types';
import { BlockEmptyState } from './BlockEmptyState';

// ─────────────────────────────────────────────
// WhatChangedBlock — 指标变化对比（Before / After 双列卡片）
// Figma: node 11201-56554
// ─────────────────────────────────────────────

export function WhatChangedBlock({ block }: { block: WhatChangedBlockType }) {
  const changes = block.changes ?? [];

  if (changes.length === 0) return <BlockEmptyState label="最新变化" />;

  return (
    <div className="flex flex-col gap-3">
      {changes.map((item, idx) => (
        <div key={idx} className="flex flex-col gap-3 rounded-xl bg-[#FAFAFA] p-[14px]">
          {/* Header：指标名 + 变化幅度 pill */}
          <div className="flex items-center justify-between gap-2 overflow-hidden">
            <Ellipse text={item.metric} className="text-[14px] font-semibold leading-[20px] text-[#1E2B24] max-w-1/2" />
            <Ellipse
              text={item.change}
              className="shrink-0 rounded-full bg-[#E5E5E5] px-[10px] py-1 text-[12px] leading-[150%] text-[#262626] overflow-hidden max-w-1/2
              "
            />
          </div>

          {/* Diff Stack：Before / After 双列 */}
          <div className="flex items-stretch gap-3">
            {/* Before */}
            <div className="flex flex-1 flex-col gap-2 rounded-lg border border-[#E5E5E5] bg-[#F8F8F7] p-3">
              <span className="text-[12px] font-medium leading-[150%] text-[#A3A3A3]">Before</span>
              <span className="text-[14px] leading-[150%] text-[#262626]">{item.previous}</span>
            </div>

            {/* After */}
            <div
              className="flex flex-1 flex-col gap-2 rounded-lg p-3"
              style={{
                background: 'rgba(243, 251, 247, 0.6)',
                border: '1px solid rgba(16, 185, 129, 0.3)',
              }}
            >
              <span className="text-[12px] font-medium leading-[150%]" style={{ color: 'rgba(6, 95, 70, 0.6)' }}>
                After
              </span>
              <span className="text-[14px] leading-[150%] text-[#064E3B]">{item.current}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
